module.exports = require("react-codemirror2");